import Slider from './Slider';

export { default as SliderTheme } from './Slider.style';
export default Slider;
